import { identityServiceApi } from '../../../../infra/identityApi.service';
import { ADMINISTRATION_API } from '../../../../common/constants/api';

export const getCountyList = async () => {
    try {
        const res = await identityServiceApi({
            method: 'get',
            url: ADMINISTRATION_API.COUNTIES,
        });

        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            error: `Get counties: ${e.message}`,
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/requests/get_county_list_request.js